import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-fill",
  "use": "icon-check-fill-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-check-fill\">\n<path d=\"M10,0c5.5,0,10,4.5,10,10s-4.5,10-10,10S0,15.5,0,10S4.5,0,10,0z M14.8,6.2l-5.7,6L6.2,9.2c-0.3-0.3-0.7-0.3-1,0\n\tc-0.3,0.3-0.3,0.8,0,1l3.4,3.6C8.7,13.9,8.9,14,9.1,14s0.4-0.1,0.5-0.2l6.2-6.5c0.3-0.3,0.3-0.8,0-1C15.5,5.9,15.1,5.9,14.8,6.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol